var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg13N(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 347,
    viewBox: "0 0 392 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.865 148.295V157.143",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.672 150.454L140.111 149.734",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.672 150.454L136.513 149.734",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.672 155.492L140.111 156.212",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.672 155.492L136.513 156.212",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.674 150.544L135.011 154.968",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.792 151.61L142.916 152.143",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.792 151.61L141.367 149.461",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.705 153.969L136.105 156.076",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.705 153.969L134.556 153.393",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.631 154.968L134.968 150.544",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.766 153.871L141.367 155.977",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.767 153.871L142.915 153.295",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136.68 151.511L134.555 152.045",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.68 151.511L136.104 149.362",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M260.934 167.885V183.053",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M260.302 171.326L263.181 170.606",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M260.302 171.326L256.703 170.606",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M260.302 179.962L263.181 181.401",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M260.302 179.962L256.703 181.401",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267.466 171.74L254.33 179.324",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M264.24 173.566L267.881 174.48",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M264.24 173.566L265.227 169.883",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M257.234 177.611L256.205 181.221",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M257.234 177.611L253.551 176.624",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M267.393 179.324L254.257 171.74",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M264.198 177.444L265.227 181.054",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M264.198 177.443L267.881 176.457",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M257.192 173.398L253.551 174.312",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M257.192 173.398L256.205 169.715",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M349.59 191.439V203.892",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M348.945 194.16L351.104 193.44",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M348.945 194.16L346.066 193.44",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M348.945 201.357L351.104 202.796",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M348.945 201.357L346.066 202.796",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M354.953 194.604L344.168 200.831",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M352.304 196.105L355.294 196.855",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M352.304 196.104L353.115 193.08",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M346.553 199.425L345.708 202.389",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M346.553 199.425L343.528 198.614",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M354.893 200.83L344.108 194.604",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M352.269 199.287L353.114 202.251",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M352.269 199.286L355.293 198.476",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M346.518 195.966L343.528 196.717",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M346.518 195.966L345.707 192.942",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3335 244.227V255.196",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7473 246.948L44.9063 246.228",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7474 246.948L40.5884 246.228",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7473 252.705L44.9063 254.144",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7474 252.705L40.5884 254.144",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0574 247.015L38.5579 252.5",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7246 248.337L48.3578 248.998",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7245 248.337L46.4382 245.673",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6575 251.262L39.9132 253.873",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6574 251.262L37.9936 250.548",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0042 252.499L38.5047 247.015",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6933 251.139L46.4376 253.75",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6934 251.139L48.3572 250.425",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6262 248.214L37.993 248.875",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6263 248.214L39.9126 245.55",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M198.942 286.166V295.063",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M198.725 288.167L200.164 287.447",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M198.725 288.167L196.566 287.447",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M198.725 293.205L200.164 293.925",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M198.725 293.205L196.566 293.925",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M202.773 288.427L195.068 292.875",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M200.881 289.499L203.017 290.035",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M200.881 289.499L201.46 287.338",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M196.771 291.872L196.167 293.99",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M196.771 291.872L194.61 291.293",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M202.731 292.875L195.026 288.426",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M200.856 291.773L201.46 293.891",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M200.856 291.773L203.017 291.194",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M196.746 289.4L194.61 289.936",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M196.746 289.4L196.167 287.239",
    stroke: "#42A0F0",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.975 263.003V339.795",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.821 281.774L295.046 268.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.821 281.774L268.169 268.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.821 322.73L295.046 336.382",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.821 322.73L268.169 336.382",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.043 282.519L248.54 320.915",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.71 291.77L317.146 296.398",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.71 291.771L303.707 273.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.241 312.248L258.031 330.527",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.241 312.248L244.592 307.251",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.676 320.915L248.172 282.519",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.497 311.395L303.708 329.674",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.497 311.395L317.146 306.398",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.028 290.917L244.593 295.545",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.028 290.918L258.031 272.269",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.975 175.003V251.795",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.821 193.774L208.046 180.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.821 193.774L181.169 180.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.821 234.73L208.046 248.382",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.821 234.73L181.169 248.382",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.043 194.519L161.54 232.915",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71 203.77L230.146 208.398",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71 203.771L216.707 185.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.241 224.248L171.031 242.527",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.241 224.248L157.592 219.251",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.676 232.915L161.172 194.519",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.497 223.395L216.708 241.674",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.497 223.395L230.146 218.398",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.028 202.917L157.593 207.545",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.028 202.918L171.031 184.269",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.975 263.003V339.795",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.821 281.774L139.046 268.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.821 281.774L112.169 268.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.821 322.73L139.046 336.382",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.821 322.73L112.169 336.382",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.043 282.519L92.5396 320.915",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.71 291.77L161.146 296.398",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.71 291.771L147.707 273.122",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.241 312.248L102.031 330.527",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.241 312.248L88.5923 307.251",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.676 320.915L92.1724 282.519",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.497 311.395L147.708 329.674",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.497 311.395L161.146 306.398",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.028 290.917L88.5928 295.545",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.028 290.918L102.031 272.269",
    stroke: "#42A0F0",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_4_189)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.562 233.765C233.629 233.92 231.676 233.999 229.705 234H92.1812C82.7149 234.035 73.3348 232.201 64.579 228.603C55.8232 225.005 47.8639 219.714 41.1577 213.032C34.4516 206.351 29.1305 198.412 25.4997 189.669C21.869 180.927 20 171.554 20 162.087C20 152.621 21.869 143.248 25.4997 134.506C29.1305 125.763 34.4516 117.824 41.1577 111.143C47.8639 104.461 55.8232 99.17 64.579 95.5718C73.3348 91.9737 82.7149 90.1397 92.1812 90.175H143.457C160.081 53.6 198.368 28 242.941 28C302.768 28 351.268 74.115 351.268 131C351.268 187.885 302.768 234 242.941 234C240.461 234 238.001 233.922 235.562 233.765Z",
    fill: "url(#paint0_linear_4_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.941 233C250.227 233 257.508 232.302 264.582 230.926C271.475 229.585 278.255 227.584 284.734 224.978C291.094 222.42 297.229 219.254 302.967 215.568C308.651 211.917 313.995 207.725 318.851 203.107C323.707 198.49 328.115 193.411 331.953 188.009C335.827 182.557 339.154 176.728 341.842 170.686C344.579 164.532 346.681 158.093 348.09 151.547C349.536 144.831 350.269 137.917 350.269 131C350.269 124.082 349.536 117.169 348.09 110.452C346.681 103.906 344.579 97.4673 341.842 91.3142C339.154 85.2716 335.827 79.4433 331.953 73.991C328.115 68.5893 323.707 63.5095 318.851 58.8928C313.995 54.2752 308.651 50.0829 302.967 46.4323C297.229 42.7461 291.094 39.5801 284.734 37.0221C278.255 34.4165 271.475 32.4154 264.582 31.0742C257.508 29.6979 250.227 29 242.941 29C221.57 29 200.931 34.9523 183.255 46.2135C174.734 51.6418 167.078 58.1939 160.498 65.6878C153.876 73.2291 148.449 81.6069 144.367 90.5885L144.101 91.1747H143.457H92.181C82.6074 91.1747 73.3208 93.0495 64.5789 96.747C60.3773 98.5242 56.3247 100.724 52.5338 103.285C48.7786 105.822 45.2474 108.735 42.0382 111.945C38.829 115.154 35.9155 118.685 33.3785 122.44C30.8174 126.231 28.6178 130.284 26.8406 134.485C23.1431 143.227 21.2683 152.514 21.2683 162.087C21.2683 171.661 23.1431 180.948 26.8406 189.689C28.6178 193.891 30.8174 197.944 33.3785 201.735C35.9155 205.49 38.829 209.021 42.0382 212.23C45.2474 215.439 48.7786 218.353 52.5338 220.89C56.3247 223.451 60.3773 225.651 64.5789 227.428C73.3208 231.125 82.6074 233 92.181 233H229.706C231.628 233 233.572 232.922 235.482 232.768L235.554 232.762L235.627 232.767C238.046 232.922 240.507 233 242.941 233ZM242.941 234C240.461 234 238.001 233.921 235.563 233.765C233.632 233.92 231.676 234 229.706 234H92.181C52.4649 234 20.2683 201.803 20.2683 162.087C20.2683 122.371 52.4649 90.1747 92.181 90.1747H143.457C160.081 53.5954 198.366 28 242.941 28C302.768 28 351.269 74.1151 351.269 131C351.269 187.885 302.768 234 242.941 234Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_189",
    x: 81.5916,
    y: 168.003,
    width: 242.555,
    height: 178.792,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4_189"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_4_189",
    x: 16,
    y: 24,
    width: 339.269,
    height: 218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_189",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_4_189"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4_189",
    x: 0,
    y: 0,
    width: 391.269,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.302 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_189",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_189",
    x1: 154.164,
    y1: 53.9561,
    x2: 220.206,
    y2: 245.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0.204
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13N);
export default __webpack_public_path__ + "static/media/13n.41773f8994235301d1aae7f73a5c96e3.svg";
export { ForwardRef as ReactComponent };